import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Features() {
  return (
    <>
      <Header />

      <section className="overflow-hidden position-relative">
        <div class="pt-lg-5 pb-lg-3 py-5 position-relative z-1">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-12 col-12">
                <div class="pe-lg-5">
                  <span className="badge bg-white-soft rounded-pill fs-5 px-4 mb-2">
                    Our Features
                  </span>
                  <h1 class="display-5 text-light fw-bold my-3 ls-sm lh-1">
                    Features That Redefine Event Photo Sharing
                  </h1>
                  <p class="mb-3 h3 lh-1 text-light fw-normal opacity-75">
                    Visualaey is built with one clear goal: to make photo
                    discovery effortless, intelligent, and instant for every
                    guest at every event. Planning a wedding, birthday, or
                    corporate gathering? Our clever AI matches your face across
                    thousands of high resolution photos and delivers your
                    captured memories in seconds, bringing them to life in a
                    whole new way.
                  </p>
                  <span className="text-white fs-4">
                    No tagging, no searching, just seamless access.
                  </span>
                  <div class="mt-3">
                    <div class="mb-2">
                      <div>
                        <p class="mb-3 fs-4 lh-sm text-white opacity-50">
                          Our platform identifies individual faces across
                          thousands of high-resolution photos, matching guests
                          with their captured memories in seconds.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    <Link
                      to="/pricing"
                      class="btn btn-white px-5 btn-md mb-lg-0 mb-5 me-1"
                    >
                      Pricing
                    </Link>
                    <Link
                      to="/book-demo"
                      class="btn btn-outline-light px-5 btn-md mb-lg-0 mb-5"
                    >
                      Request Demo
                    </Link>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12 col-12">
                <img
                  src="/assets/images/11.jpg"
                  class="object-fit-cover w-100 rounded-5"
                  height="400"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-4">
          <div className="d-flex justify-content-center">
            <div className="col-lg-8 col-12">
              <div className="text-center mb-6">
                <h2 className="display-5 text-white fw-medium ls-sm mt-4">
                  <span className="colorful-text">+1.8 Million Users</span>{" "}
                  using Visualaey
                </h2>
                <p class="mb-3 h3 lh-sm text-light lead fw-light opacity-75">
                  Discover how millions effortlessly find their event photos
                  with just one selfie. Visualaey makes photo sharing smart,
                  instant, and personal.
                </p>
              </div>
            </div>
          </div>
        </div>

        <section class="position-relative z-1 mt-2 mb-5">
          <div class="container">
            <div class="row align-items-center g-0 bg-dark-3 light-border rounded-5 overflow-hidden">
              <div class="col-lg-6 col-12">
                <div className="m-5 rounded-5 p-5">
                  <h2 class="text-white fw-medium ls-sm mt-2 mb-3">
                    Gallery Powered by <span class="">Your Face</span>
                  </h2>
                  <p class="lead text-white opacity-75 mb-5 fw-normal lh-sm">
                    Visualaey is an AI powered, cloud native platform that
                    automatically finds and delivers every photo you're in, just
                    by uploading a selfie. Your private gallery, delivered in
                    moments, no effort needed.
                  </p>
                  <div class="d-flex">
                    <div class="text-center">
                      <Link
                        to="/signup"
                        class="btn btn-gradient-bg-3 px-6 py-2 fs-4 btn-md rounded-4 text-white fw-normal border-0"
                      >
                        Create Account{" "}
                        <i className="bi bi-arrow-right ms-2"></i>
                      </Link>
                      <p className="text-light opacity-75 p-0 mt-2">
                        No credit card required
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div className="position-relative left-black-overlay">
                  <img
                    src="/assets/images/10.jpg"
                    className="w-100 rounded-end-5 object-fit-cover"
                    height="450"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="red-blur-flow"></div>
        <div class="blue-blur-flow"></div>
      </section>

      <section class="pt-lg-4 pb-lg-3 py-5 mb-lg-6">
        <div class="container mt-2">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <img
                src="/assets/images/2.jpg"
                class="object-fit-cover w-100 rounded-5"
                height="400"
              />
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <div class="ps-lg-6 mt-lg-0 mt-5">
                <span className="badge bg-white-soft rounded-pill fs-5 px-4 mb-2">
                  Memories Effortless
                </span>

                <h2 class="text-white my-3 ls-sm lh-1 fw-normal">
                  A cloud-native, AI-driven platform that makes organizing and
                  discovering memories effortless
                </h2>
                <p class="mb-3 h3 lh-1 text-white opacity-75 fw-normal">
                  Transform the way you capture, organize, and share event
                  memories. Say goodbye to endless scrolling and manual
                  sorting—and say hello to a new era of intelligent photo
                  sharing.
                </p>
                <div class="mt-5">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm">
                        Your first 3 events are completely free — no credit card
                        required. Perfect for testing the platform during your
                        next event. When you're ready for more, upgrade to a
                        simple, affordable subscription plan.
                      </p>
                    </div>
                  </div>
                </div>
                <Link
                  to="/contact"
                  class="btn btn-outline-light px-5 btn-md mt-4 mb-lg-0 mb-5"
                >
                  Contact Visualaey
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="position-relative z-1 mt-lg-8 mt-0 mb-5">
        <div class="container">
          <div class="row align-items-center g-0 bg-dark-1 rounded-5 overflow-hidden">
            <div class="col-lg-7 col-12">
              <div className="m-5 rounded-5 p-5">
                <h2 class="text-white fw-medium ls-sm mt-2 mb-3">
                  <span class="">Face-Powered</span> Gallery
                </h2>
                <p class="lead text-white opacity-75 mb-5 fw-normal lh-sm">
                  Visualaey is an AI-powered, cloud-native platform that
                  automatically finds and delivers every photo you're in—just by
                  uploading a selfie.
                </p>
                <div class="">
                  <Link
                    to="/login"
                    class="btn btn-light px-6 btn-md rounded-pill"
                  >
                    Get Started
                  </Link>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-12">
              <img
                src="/assets/images/14.jpg"
                className="w-100 rounded-end-5 object-fit-cover"
                height="320"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Features;
